import {
  Box,
  Button,
  Flex,
  FormControl,
  Heading,
  useColorModeValue,
  Text,
  Icon,
  InputRightElement,
  Tooltip,
  Input,
  InputGroup,
  FormLabel,
} from '@chakra-ui/react';

import InputField from 'components/fields/InputField';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Custom components
import OnToast from 'components/alerts/toast';
import { PasswordValidation } from 'utils/formValidations/validations';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import { updatePassword, checkPasswordset } from 'utils/creator/creator';
import { HashLoader } from 'react-spinners';
const SetPasswordCentered: React.FC = () => {
  const [password, setPassword] = useState<{
    password: string;
    confirmPassword: string;
  }>({ password: '', confirmPassword: '' });
  const [err, setErr] = useState(false);
  const [alert, setAlert] = useState(false);
  const [msg, setMsg] = useState(null);
  const { type, uuid } = useParams();
  const [loading, setLoading] = useState(true);
  const [urlFound, setUrlFound] = useState(false);
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [eyeShow, setEyeShow] = React.useState(false);

  const textColor = useColorModeValue('navy.700', 'white');

  const textColorSecondary = 'gray.400';

  useEffect(() => {
    const checkUrl = async () => {
      try {
        let dataToSend = {
          uuid: uuid,
          type: type,
        };

        let checkPasswordsetResult = await checkPasswordset(
          uuid,
          JSON.stringify(dataToSend),
        );

        setLoading(true);
        if (checkPasswordsetResult?.status === 'Success') {
          // const gamePlayRoutePath = 'https://play.atlantisworld.co';
          // const gamePlayRoutePath = 'http://192.168.1.39:3001';
          // const gamePlayRoutePath = 'https://test.atlantisworld.co';
          const gamePlayRoutePath = 'https://leap.atlantisworld.co';
          // const gamePlayRoutePath = 'https://play.atlantisworld.co';
          const url = `${gamePlayRoutePath}`;
          window.location.href = url;
        } else {
          setLoading(false);
        }
      } catch (e) {
        setMsg('An error occurred while checking the URL');
        setLoading(false);
      }
    };

    checkUrl();
  }, [uuid, type]);

  const handleClick = () => setShow(!show);
  const handleEyeClick = () => setEyeShow(!eyeShow);
  const handleChange = (val: string, field: string) => {
    if (field === 'pwd') {
      setPassword({ ...password, password: val });
    } else {
      setPassword({ ...password, confirmPassword: val });
    }
  };
  const handleSubmit = async () => {
    if (password.confirmPassword === '') {
      setErr(true);
      setAlert(true);
      setMsg('Confirm Password Field is Empty');
    } else if (password.password == '') {
      setErr(true);
      setAlert(true);
      setMsg('Password Field is Empty');
    } else if (
      password.confirmPassword !== '' &&
      password.confirmPassword != password.password
    ) {
      setErr(true);
      setAlert(true);
      setMsg('Password and Confirm passwords are not matched');
    } else {
      let valid = PasswordValidation(password.password, 8, 16);
      if (valid.err) {
        setErr(true);
        setAlert(true);
        setMsg(valid.msg);
      } else {
        setErr(false);
        setAlert(false);
        let dataToSend = {
          password: password.password,
          uuid: uuid,
          type: type,
        };

        let updatePasswordResult = await updatePassword(
          uuid,
          JSON.stringify(dataToSend),
        );

        setMsg(updatePasswordResult?.message);
        setAlert(true);
        updatePasswordResult?.status === 'Success'
          ? setErr(false)
          : setErr(true);

        setTimeout(function () {
          setErr(false);
          setMsg('');
          setAlert(false);

          if (type === 'learner') {
            // const gamePlayRoutePath = 'https://play.atlantisworld.co'
            //  const gamePlayRoutePath = 'http://192.168.1.39:3001';
            // const gamePlayRoutePath = 'https://test.atlantisworld.co';
              const gamePlayRoutePath = 'https://leap.atlantisworld.co';
            // const gamePlayRoutePath = 'https://play.atlantisworld.co';

            const url = `${gamePlayRoutePath}`;

            window.location.href = url;
          }
          if (type === 'creator') {
            // const gamePlayRoutePath = 'https://create.atlantisworld.co'
            const gamePlayRoutePath = 'https://testcreator.atlantisworld.co';
            // const gamePlayRoutePath = 'https://create.atlantisworld.co/';
            // const gamePlayRoutePath = 'http://192.168.1.39:3000';

            const url = `${gamePlayRoutePath}`;
            window.location.href = url;
          } else {
            navigate('/auth/sign-in/default');
          }
        }, 2500);
      }
    }
    //update the password in creator table if both passward and confirm password matched
  };

  if (loading) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
        }}
      >
        <HashLoader color="#3b38e0" />
      </div>
    );
  }

  return (
    <Flex
      w="100%"
      h="100vh"
      alignItems="center"
      justifyContent="center"
      px={{ base: '25px', md: '0px' }}
      flexDirection="column"
    >
      <Box mb="34px">
        <Heading
          color={textColor}
          fontSize={{ base: '3xl', md: '36px' }}
          mb="16px"
        >
          Set your password?
        </Heading>
      </Box>
      <Flex
        zIndex="2"
        direction="column"
        w={{ base: '100%', lg: '456px' }}
        maxW="100%"
        background="transparent"
        borderRadius="15px"
        align="start"
      >
        <FormLabel
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          display="flex"
        >
          New Password<Text color={'red'}>*</Text>
        </FormLabel>
        <InputGroup size="md">
          <Input
            isRequired={true}
            fontSize="sm"
            placeholder="Min. 8 characters"
            mb="24px"
            size="lg"
            type={show ? 'text' : 'password'}
            variant="auth"
            id="ctPassword"
            name="ctPassword"
            onChange={(e: any) => handleChange(e.target.value, 'pwd')}
            value={password.password}
          />
          <Tooltip label={show ? 'Hide Password' : 'Show Password'}>
            <InputRightElement display="flex" alignItems="center" mt="4px">
              <Icon
                color={textColorSecondary}
                _hover={{ cursor: 'pointer' }}
                as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                onClick={handleClick}
              />
            </InputRightElement>
          </Tooltip>
        </InputGroup>

        <Text fontSize={13} mb="15px">
          Note: The password must include :8 Characters,a digit,a special
          character,uppercase
        </Text>
        <FormLabel
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          display="flex"
        >
          Confirm Password<Text color={'red'}>*</Text>
        </FormLabel>
        <InputGroup size="md">
          <Input
            isRequired={true}
            fontSize="sm"
            placeholder="Min. 8 characters"
            mb="24px"
            size="lg"
            type={eyeShow ? 'text' : 'password'}
            variant="auth"
            id="cnfPassword"
            name="cnfPassword"
            onChange={(e: any) => handleChange(e.target.value, 'cnf')}
            value={password.confirmPassword}
            autoComplete="off"
          />
          <Tooltip label={eyeShow ? 'Hide Password' : 'Show Password'}>
            <InputRightElement display="flex" alignItems="center" mt="4px">
              <Icon
                color={textColorSecondary}
                _hover={{ cursor: 'pointer' }}
                as={eyeShow ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                onClick={handleEyeClick}
              />
            </InputRightElement>
          </Tooltip>
        </InputGroup>

        {alert ? (
          <OnToast
            msg={msg}
            status={err ? 'error' : 'success'}
            setAlert={setAlert}
          />
        ) : null}
        <Button
          fontSize="sm"
          variant="brand"
          fontWeight="500"
          w="100%"
          h="50"
          mb="24px"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Flex>
    </Flex>
  );
};

export default SetPasswordCentered;
